import * as React from 'react';



export default class AssociatedParty extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <g strokeWidth="1" fillRule="evenodd" transform="translate(-224.000000, -65.000000)">
            <g id="Group-18" transform="translate(224.000000, 65.000000)">
                <g id="Page-1-Copy-7" transform="translate(2.000000, 1.000000)">
                    <polygon id="Fill-1" className="strokeColor" stroke="currentColor" fill="currentColor" points="11.1722178 13.6994 12.4802319 13.6994 12.4802319 1.0994 11.1722178 1.0994"></polygon>
                    <path d="M12.0455793,13.7375 L0.861964444,13.7375 C0.586112593,13.7375 0.363253333,13.5219 0.363253333,13.2566 L0.363253333,1.6191 C0.363253333,1.3531 0.586112593,1.1375 0.861964444,1.1375 L12.0455793,1.1375 C12.3214311,1.1375 12.5442904,1.3531 12.5442904,1.6191 L12.5442904,13.2566 C12.5442904,13.5219 12.3214311,13.7375 12.0455793,13.7375 Z" id="Stroke-1" strokeLinecap="round"></path>
                    <path d="M2.09850667,0.35 L2.09850667,2.0125" id="Stroke-3" strokeLinecap="round"></path>
                    <path d="M4.27628444,0.35 L4.27628444,2.0125" id="Stroke-5" strokeLinecap="round"></path>
                    <path d="M6.45406222,0.35 L6.45406222,2.0125" id="Stroke-7" strokeLinecap="round"></path>
                    <path d="M8.63147704,0.35 L8.63147704,2.0125" id="Stroke-9" strokeLinecap="round"></path>
                    <path d="M10.8092548,0.35 L10.8092548,2.0125" id="Stroke-11" strokeLinecap="round"></path>
                    <path d="M7.89066963,5.10272 C7.89066963,5.82162 7.28597333,6.40472 6.54117333,6.40472 C5.79564741,6.40472 5.19095111,5.82162 5.19095111,5.10272 C5.19095111,4.38382 5.79564741,3.80142 6.54117333,3.80142 C7.28597333,3.80142 7.89066963,4.38382 7.89066963,5.10272 Z" id="Stroke-13" strokeLinecap="round"></path>
                    <path d="M10.0769407,11.1125 L3.00497037,11.1125 C2.8155037,11.1125 2.66160741,10.9641 2.66160741,10.7814 L2.66160741,10.0765 C2.66160741,8.6184 3.88697037,7.4375 5.39834815,7.4375 L5.74824444,7.5047 C6.27163704,7.6048 6.81027407,7.6048 7.33366667,7.5047 L7.68356296,7.4375 C9.19494074,7.4375 10.4203037,8.6184 10.4203037,10.0765 L10.4203037,10.7814 C10.4203037,10.9641 10.2664074,11.1125 10.0769407,11.1125 Z" id="Stroke-15" strokeLinecap="round"></path>

                </g>
            </g>
        </g>
      </svg>
    )
  }
}
